import { Injectable } from '@angular/core';

@Injectable()
export class NavbarService {
  isVisible: boolean;
  title: String = 'MY WORKSPACE';
  isLoggedIn: string = 'false';
  planid: string;
  email: string;
  isAdmin: string;
  productname: string = 'SHAREVIEW 3D';
  currenturlnavid: number;

  constructor() {
    this.isVisible = false;
  }
// this service will control the visibility of the navbar in every front facing component.
// this service may be extended in the future to also change the title text on the navbar component when it is loaded up.
// TODO - incorporate this service into projects, workspace, useradmin etc.
  hide() {
    this.isVisible = false;
    this.configure();
  }

  show(title: String) {
    this.isVisible = true;
    this.title = title;
    this.configure();
  }

  setNavID(id: number) {
    this.currenturlnavid = id;
  }

  toggle() {
    this.isVisible = !this.isVisible;
  }

  configure() {
    this.email = localStorage.getItem('mr_email');
    this.planid = localStorage.getItem('mr_planid');
    this.isAdmin = localStorage.getItem('isAdmin');

    console.log('isAdmin:', this.isAdmin);

    if (typeof this.planid == 'undefined' || this.planid === '') {
      this.planid = '1';
    }

    if (this.planid === '1') {
      this.productname = 'SHAREVIEW 3D';
    }

    if (this.planid === '2') {
      this.productname = 'QUOTE iT 3D';
    }

    if (this.planid === '3') {
      this.productname = 'QUOTE iT 3D ITAR';
    }

    /*this.route = this.router.url;
    if (this.route === '/workspace') {
      this.current = 0;
    } else if (this.route === '/projects') {
      this.current = 1;
    } else if (this.route === '/customers') {
      this.current = 2;
    } else if (this.route === '/useradmin') {
      this.current = 3;
      // if(!($('#settings').hasClass('active')))
      //   document.getElementById('#settings').click();
    } else if (this.route === '/resourceadmin') {
      this.current = 4;
      // if(!($('#settings').hasClass('active')))
      //   document.getElementById('settings').click();
    } else if (this.route === '/materialadmin') {
      this.current = 5;
      // if(!($('#settings').hasClass('active')))
      //   document.getElementById('settings').click();
    } else if (this.route === '/projectinfo') {
      this.current = 6;
    } else if (this.route === '/shapesearch') {
      this.current = 7;
    } else if (this.route === '/accountadmin') {
      this.current = 11;
    }*/
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/navbar/navbar.service.ts